import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

const ComputationDisplayLayout = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={clsx(
        'tw-bg-cfo-blue-200',
        'tw-min-w-[339px] tw-max-w-[339px] tw-w-full',
        'tw-pt-[5px] tw-pb-[30px] tw-px-[20px]'
      )}
    >
      {children}
    </div>
  );
};

export default ComputationDisplayLayout;
